module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "photoCell",
    staticClass: "photo-cell col-6 col-md-6 col-lg-3",
    style: ({
      height: _vm.photoCellHeight + 'px'
    })
  }, [_c('div', {
    staticClass: "photo-cell-inner h-100 p-1 relative-position",
    class: {
      favorite: _vm.input.isBuyTarget
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column h-100"
  }, [_c('div', {
    staticClass: "photo-no text-center clearfix pl-3"
  }, [_c('div', [_vm._v(_vm._s(_vm.photo.photo_no))])]), _vm._v(" "), _c('div', {
    ref: "photoImageWrap",
    staticClass: "flex-grow-1",
    style: ({
      height: _vm.photoImageWrapHeight + 'px'
    })
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.smallThumbnailUrl),
      expression: "smallThumbnailUrl",
      arg: "background-image"
    }],
    staticClass: "photo-image contain",
    on: {
      "click": _vm.showPhotoImageModal
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row no-gutters cart-photo-operation align-items-center"
  }, [_c('div', {
    staticClass: "pl-5 col-auto text-center"
  }, [_c('span', {
    staticClass: "size-info d-inline-block py-1 px-1"
  }, [_vm._v(_vm._s(_vm.photoSizeMark))])]), _vm._v(" "), _c('div', {
    staticClass: "price-info col text-center"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['91'][3]"
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-24d6122a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/partials/Order/Confirm/SnapHorizonPhoto.vue
// module id = 679
// module chunks = 0